export default __webpack_public_path__ + "static/media/bg.f066b4b1.jpg";